<div id="shared-scrolling-container">

  @if (data?.length > 0) {
    @switch (scrollingType) {
      @case (scrollingTypeEnum.INFINITE) {
        <app-shared-scrolling-infinite
          (scrolledToThreshold)="scrollTriggered()"
          [enableAutoFillWhenShort]="enableAutoFillWhenShort"
          [idProperty]="idProperty"
          [isScrollDataLoading]="isScrollDataLoading"
          [itemTemplate]="itemTemplate"
          [scrollData]="scrollData"
          [scrollDataRevision]="scrollDataRevision"
          [scrollThresholdPx]="threshold">
          <ng-content select="[scrollLoader]"></ng-content>
        </app-shared-scrolling-infinite>
      }
      @default {
        <app-shared-scrolling-virtual
          (scrolledToEnd)="scrollTriggered()"
          [idProperty]="idProperty"
          [isScrollDataLoading]="isScrollDataLoading"
          [itemHeight]="itemHeight"
          [itemTemplate]="itemTemplate"
          [scrollData]="scrollData"
          [threshold]="threshold">
          <ng-content select="[scrollLoader]"></ng-content>
        </app-shared-scrolling-virtual>
      }
    }
  } @else {
    <ng-content select="[noData]"></ng-content>
  }
</div>
